import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ServicePropertiesPropertyName } from "../common.speech/Exports";
import { PropertyId } from "../sdk/Exports";
import { QueryParameterNames } from "./QueryParameterNames";
export var ConnectionFactoryBase = /*#__PURE__*/function () {
  function ConnectionFactoryBase() {
    _classCallCheck(this, ConnectionFactoryBase);
  }

  _createClass(ConnectionFactoryBase, [{
    key: "setCommonUrlParams",
    value: function setCommonUrlParams(config, queryParams, endpoint) {
      this.setUrlParameter(PropertyId.SpeechServiceConnection_EnableAudioLogging, QueryParameterNames.EnableAudioLogging, config, queryParams, endpoint);
      this.setUrlParameter(PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, QueryParameterNames.EnableWordLevelTimestamps, config, queryParams, endpoint);
      this.setUrlParameter(PropertyId.SpeechServiceResponse_ProfanityOption, QueryParameterNames.Profanify, config, queryParams, endpoint);
      this.setUrlParameter(PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, QueryParameterNames.InitialSilenceTimeoutMs, config, queryParams, endpoint);
      this.setUrlParameter(PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, QueryParameterNames.EndSilenceTimeoutMs, config, queryParams, endpoint);
      this.setUrlParameter(PropertyId.SpeechServiceResponse_StablePartialResultThreshold, QueryParameterNames.StableIntermediateThreshold, config, queryParams, endpoint);
      var serviceProperties = JSON.parse(config.parameters.getProperty(ServicePropertiesPropertyName, "{}"));
      Object.keys(serviceProperties).forEach(function (value, num, array) {
        queryParams[value] = serviceProperties[value];
      });
    }
  }, {
    key: "setUrlParameter",
    value: function setUrlParameter(propId, parameterName, config, queryParams, endpoint) {
      var value = config.parameters.getProperty(propId, undefined);

      if (value && (!endpoint || endpoint.search(parameterName) === -1)) {
        queryParams[parameterName] = value.toLocaleLowerCase();
      }
    }
  }]);

  return ConnectionFactoryBase;
}();